module.exports = __webpack_public_path__ + "img/commoditychecked.fd7c2f49.svg";